/* @flow */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Words } from 'admin/common/resources';
import waitForBackgroundTask from 'admin/common/utils/wait-for-background-task';

function SynonymWordsSyncButton({ buttonText }) {
    const [isLoading, setIsLoading] = useState();

    return (
        <button
            disabled={isLoading}
            onClick={async () => {
                setIsLoading(true);
                const f = () => Words.segment('sync').raw().post();
                await waitForBackgroundTask(f, false);
                setIsLoading(false);
            }}
            className="btn btn-secondary pull-right mr-1"
        >
            {isLoading && (
                <React.Fragment>
                    <i className="fa fa-spin fa-circle-o-notch" />
                    &nbsp;
                </React.Fragment>
            )}
            {buttonText}
        </button>
    );
}

SynonymWordsSyncButton.propTypes = {
    buttonText: PropTypes.string,
};

export default SynonymWordsSyncButton;



// WEBPACK FOOTER //
// ./resources/assets/admin/global/js/components/SynonymWordsSyncButton.js